__turbopack_context__.v({
  "arrow": "popover-module__zm058W__arrow",
  "dropdown": "popover-module__zm058W__dropdown",
});
